import script from "./AdministratorProjectFormStep3.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministratorProjectFormStep3.vue?vue&type=script&setup=true&lang=js"

import "./AdministratorProjectFormStep3.vue?vue&type=style&index=0&id=f0fa7504&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0fa7504"]])

export default __exports__